namespace Areas.Observations {
    "use strict";
    

    //
    //CRUD functions
    //

    var formObservationOpen, formObservationClose;
        

    var formCrudOps: FormCrudOperations;
    $(() => { init(); });

    function init() {

        formCrudOps = new FormCrudOperations("Observations");

        formObservationOpen = new UpdateOperations("ObservationsForm",
            "/Observations/Edit/OpenObservation");

        formObservationClose = new UpdateOperations("ObservationsForm",
            "/Observations/Edit/CloseObservation");


    }

    export function openObservation(e: any) {
        formObservationOpen.updateRecordWithId();
    }

    export function closeObservation(e: any) {
        formObservationClose.updateRecordWithId();
    }

    
    export function insertRecord(e: any) {
        formCrudOps.insertRecord();
    }

    export function updateRecord(e: any) {
        formCrudOps.updateRecord();
    }

    export function voidRecord() {
        const verifyVoid = window.confirm("Are you sure you would like to VOID this record?");

        if (verifyVoid) {
            const form = $("#ObservationsForm").dxForm("instance");
            const keyId: any = form.option("KeyId");
            const projectId = form.option("ProjectId");

            if (keyId != null && projectId != null) {
                sendRequest(`/Observations/Edit/VoidObservation/${keyId}/${projectId}/`, "", "PUT");
            }
        }
    }

}
